var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { INSIDER_CART_CHANGED, silentCartUpdate, } from './mod-cart-event-bus.js';
// Guard distinctUntilChanged — descarta evento se o token não mudou.
// O cart.token é fixo por sessão no Shopify, então, na prática, só persiste uma vez.
let _lastPersistedToken = null;
let _currentToken = '';
let _lastPersistedStableKey = null;
function readStableId() {
    try {
        return localStorage.getItem('STATSIG_LOCAL_STORAGE_STABLE_ID') || null;
    }
    catch (_a) {
        return null;
    }
}
function persistStableId() {
    return __awaiter(this, void 0, void 0, function* () {
        const stableID = readStableId();
        if (!stableID)
            return;
        // Inclui o token para persistir novamente se o Shopify trocar o carrinho.
        const key = JSON.stringify([_currentToken, stableID]);
        if (key === _lastPersistedStableKey)
            return;
        _lastPersistedStableKey = key;
        try {
            yield silentCartUpdate({ attributes: { stableID } });
        }
        catch (err) {
            if (_lastPersistedStableKey === key)
                _lastPersistedStableKey = null;
            console.warn('[cart-attribute-tracker] Failed to persist stableID:', err);
        }
    });
}
function syncCheckoutForms() {
    const stableID = readStableId();
    if (!stableID)
        return;
    // O POST nativo também leva o atributo caso o update assíncrono esteja pendente.
    document.querySelectorAll('#cart, #CartDrawer-Form').forEach((form) => {
        let input = form.querySelector('input[name="attributes[stableID]"]');
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'attributes[stableID]';
            form.appendChild(input);
        }
        input.value = stableID;
    });
}
function persistCartId(token) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token === _lastPersistedToken)
            return;
        // Seta antes do await para evitar race condition:
        // se um segundo evento chegar antes do fetch completar, cai no guard acima.
        _lastPersistedToken = token;
        console.debug(`[cart-attribute-tracker] persist cartId: ${token}`);
        try {
            yield silentCartUpdate({ attributes: { _cartId: token } });
        }
        catch (err) {
            // Reverte em caso de erro para permitir nova tentativa
            _lastPersistedToken = null;
            console.warn('[cart-attribute-tracker] Failed to persist cartId:', err);
        }
    });
}
document.addEventListener(INSIDER_CART_CHANGED, (e) => {
    var _a;
    const { cart } = e.detail;
    if (cart === null || cart === void 0 ? void 0 : cart.token) {
        _currentToken = cart.token;
        persistCartId(cart.token);
        const stableID = readStableId();
        if (stableID && ((_a = cart.attributes) === null || _a === void 0 ? void 0 : _a.stableID) === stableID) {
            _lastPersistedStableKey = JSON.stringify([cart.token, stableID]);
        }
        else {
            persistStableId();
        }
    }
});
window.addEventListener('statsigReady', (e) => {
    var _a;
    if (!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.ready))
        return;
    syncCheckoutForms();
    persistStableId();
});
// Capture cobre formulários recriados pelo drawer e handlers que chamam form.submit().
document.addEventListener('click', (e) => {
    if (e.target instanceof Element && e.target.closest('[name="checkout"]')) {
        syncCheckoutForms();
    }
}, true);
document.addEventListener('submit', (e) => {
    if (e.target instanceof HTMLFormElement && ['cart', 'CartDrawer-Form'].includes(e.target.id)) {
        syncCheckoutForms();
    }
}, true);
// Em visitas seguintes o ID já pode existir antes do evento statsigReady.
syncCheckoutForms();
persistStableId();
